import { useLanguageChange } from 'hooks/useLanguageChange'

const LanguageSwitcher = () => {
  const { language, onLangChange } = useLanguageChange()

  const handleLanguageChange = () => {
    onLangChange(language === 'ru' ? 'kk' : 'ru')
  }

  return (
    <button
      type='button'
      className={`w-8 h-8 rounded-full bg-[var(--bg-header-icon)] text-main text-[12px]`}
      onClick={handleLanguageChange}
    >
      {language === 'ru' ? 'Қаз' : 'Рус'}
    </button>
  )
}

export default LanguageSwitcher
